import React from 'react';
import { InfoOutlinedIcon } from 'element';
import { Tooltip } from 'oxygen-elements';

export const DutyHolderChangeHint = () => (
  <div style={{ padding: '4px 16px 8px' }}>
    <Tooltip title="Duty holder is changing">
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          color: '#545454',
          cursor: 'default',
          fontSize: 14,
        }}
      >
        <InfoOutlinedIcon style={{ fontSize: 16, color: '#225990' }} />
        Duty holder is changing
      </span>
    </Tooltip>
  </div>
);
